import { useAuthenticatedApi, currentDatabaseSelector, selectedStateHighwaysSubnetworkState } from '@transport-insights/uikit';
import { useConfig } from '@src/context/config';
import { useRecoilValue } from 'recoil';
import { selectedRegionRoadTypeState, selectedTemporaryRegionRoadTypeState } from '../state';

export default () => {
  const { PERFORMANCE_API_URL } = useConfig();
  const api = useAuthenticatedApi(PERFORMANCE_API_URL);
  const rca = useRecoilValue(currentDatabaseSelector);
  const selectedSubnetwork = useRecoilValue(selectedStateHighwaysSubnetworkState);
  const selectedRegionRoadType = useRecoilValue(selectedRegionRoadTypeState);
  const selectedTemporaryRegionRoadType = useRecoilValue(selectedTemporaryRegionRoadTypeState);
  const queryParams = [];
  if (rca?.id === 81) {
    queryParams.push(`subnetwork=${selectedSubnetwork}`);
  }
  if (rca?.id >= 1000) {
    queryParams.push(`shlr=${selectedTemporaryRegionRoadType || selectedRegionRoadType}`);
  }
  return {
    async getActivityManagement(type, rcaId, lockYear) {
      const url = `/activity-management/${type}/${rcaId}/${lockYear}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getServicePerformanceKPI(rcaId, lockYear) {
      const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
      const url = `/service-performance/service-performance-kpi/${rcaId}/${lockYear}${queryString}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getReport(name, rcaId, lockYear, framework) {
      if (framework) {
        queryParams.push(`framework=${framework}`);
      }
      const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
      const url = `${name}/${rcaId}/${lockYear}${queryString}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getAnnualReports(rcaId) {
      const url = `/annual-reports/${rcaId}/`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async downloadReport(fileUrl) {
      const url = '/annual-reports/download';
      const res = await api.post(url, { path: fileUrl }, {
        responseType: 'blob',
      });
      return res?.data || null;
    },
    async getActivityManagementPlans(rcaId) {
      const res = await api.get(`/activity-management-plans/${rcaId}/`);
      return res?.data || [];
    },
    async getMiscActivityManagementPlans(rcaId) {
      const url = `/activity-management-plans-misc/${rcaId}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async downloadActivityManagementPlan(rcaId, fileUrl) {
      const res = await api.post(`/activity-management-plans/${rcaId}/download`, { path: fileUrl }, {
        responseType: 'blob',
      });
      return res?.data || null;
    },
    async getKpi(report, rcaId) {
      const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
      const url = `${report}/kpi/${rcaId}${queryString}`;
      const res = await api.get(url);
      return res?.data || null;
    },
    async getStateHighwaysData(reportUrl) {
      const res = await api.get(reportUrl);
      return res?.data || {};
    },
    async getStateHighwaysSubnetworks(groupType) {
      const res = await api.get(`/state-highway-subnetworks/${groupType || ''}`);
      return res?.data || [];
    },
  };
};
